/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from "react";
import { useTranslation } from "next-i18next";
import GrupoIcon from "@assets/icons/dropdown-grupo.svg";
import CultivoIcon from "@assets/icons/dropdown-cultivo.svg";
import ArrowDownIcon from "@assets/icons/arrow-down.svg";
import ArrowUpIcon from "@assets/icons/arrow-up.svg";
import styles from "./ensayos-dropdown.module.scss";
import { Image, TemplateText } from "../../atoms";
import { useOutsideClick } from "@hooks/useOutsideClick";

export default function EnsayosDropdown(props: any) {
  const ref = useRef<any>(null);
  const { t } = useTranslation();
  const { onChange, productos, cultivos, cultivoInicial, productoInicial } =
    props;
  const [visible, setVisible] = useState<any>(null);
  const [cultivoSelected, setCultivoSelected] = useState(cultivoInicial);
  const [productoSelected, setProductoSelected] = useState(productoInicial);

  const handleClickOutside = (evt: any) => {
    if (ref.current && !ref.current.contains(evt.target)) {
      setVisible(null);
    }
  };

  useOutsideClick(ref, () => {
    setVisible(null);
  });

  const toggleDropdown = (item: any) => {
    if (visible === item) {
      setVisible(null);
    } else {
      setVisible(item);
    }
  };

  const handleValueChange = (prop: any, value: any) => {
    if (prop === "producto") {
      setProductoSelected(value);
    } else if (prop === "cultivo") {
      setCultivoSelected(value);
    }
    setVisible(false);
    onChange(prop, value);
  };
  return (
    <div ref={ref} className={styles.root}>
      <div className={styles.dropdownwrapper}>
        <button
          type="button"
          className={styles.headerWrapper}
          onClick={() => toggleDropdown(0)}
        >
          <GrupoIcon />
          <div className={styles.value}>
            <TemplateText template="micro" className={styles.title}>
              {t("DropdownEnsayos.label1")}
            </TemplateText>

            <div className={styles.labelContainer}>
              <TemplateText template="merry" className={styles.label}>
                {cultivoSelected === null
                  ? t("DropdownEnsayos.default")
                  : cultivoSelected.nombre}
              </TemplateText>
              {visible === 0 ? (
                <ArrowUpIcon className={styles.toggleIcon} />
              ) : (
                <ArrowDownIcon className={styles.toggleIcon} />
              )}
            </div>
          </div>
        </button>
        <ul
          style={{ display: visible === 0 ? "block" : "none" }}
          className={styles.list}
        >
          <li
            key="null"
            onClick={() => {
              handleValueChange("cultivo", null);
            }}
          >
            <TemplateText template="small">Todos</TemplateText>
          </li>
          {cultivos.map((item: any) => (
            <li
              key={item.nombre}
              onClick={() => {
                handleValueChange("cultivo", item);
              }}
            >
              <Image src={item.icono} alt={item.nombre} />
              <TemplateText template="small">{item.nombre}</TemplateText>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.dropdownwrapper}>
        <button
          type="button"
          className={styles.headerWrapper}
          onClick={() => toggleDropdown(1)}
        >
          <CultivoIcon />
          <div className={styles.value}>
            <TemplateText template="micro" className={styles.title}>
              {t("DropdownEnsayos.label2")}
            </TemplateText>

            <div className={styles.labelContainer}>
              <TemplateText template="merry" className={styles.label}>
                {productoSelected === null
                  ? t("DropdownEnsayos.default")
                  : productoSelected.nombre}
              </TemplateText>

              {visible === 0 ? (
                <ArrowUpIcon className={styles.toggleIcon} />
              ) : (
                <ArrowDownIcon className={styles.toggleIcon} />
              )}
            </div>
          </div>
        </button>
        <ul
          style={{ display: visible === 1 ? "block" : "none" }}
          className={styles.list}
        >
          <li
            key="null"
            onClick={() => {
              handleValueChange("producto", null);
            }}
          >
            <TemplateText template="small">Todos</TemplateText>
          </li>
          {productos.map((item: any) => (
            <li
              key={item.nombre}
              onClick={() => {
                handleValueChange("producto", item);
              }}
            >
              <TemplateText template="small">{item.nombre}</TemplateText>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
